import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import * as _ from 'lodash';
import {ProductListComponent} from '../product-list/product-list.component';
import {MODAL_CONFIG} from '../../../services/constant';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'product-list-detail',
  templateUrl: './product-list-detail.component.html',
  styleUrls: ['./product-list-detail.component.scss']
})
export class ProductListDetailComponent implements OnInit {
  modalRef: BsModalRef;
  product: any = {};
  groups: any = [];
  companyGroupID = [];
  title = '';
  createMode = false;
  errorMessage: string = null;
  errorMsgForShow: string = null;
  errorMsgForShows: string = null;
  parent: ProductListComponent = null;
  checkUser = false;


  @ViewChild('modalTemplate') modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: BsModalService,
              private translate: TranslateService) {
  }

  open(parent: ProductListComponent, selectedUser) {
    this.parent = parent;
    this.errorMessage = null;

    if (selectedUser != null) {
      this.product = _.cloneDeep(selectedUser);
      this.createMode = false;
      this.companyGroupID = [];
      this.checkUser = true;
      this.title = this.translate.instant('PRODUCT.LIST.MODAL.TITLE') + ' : ' + this.product.display;
    } else {
      this.product = {'product_id': '', 'name_en': '', 'name_th': '', 'vat': ''};
      this.createMode = true;
      this.checkUser = false;
      this.title = this.translate.instant('PRODUCT.LIST.MODAL.ADD-USER');
    }

    this.modalRef = this.modalService.show(this.modalTemplate, MODAL_CONFIG);
  }

  ngOnInit() {
  }

  submit() {
    if (this.translate.currentLang !== 'en') {
      const errorField = [];
      this.errorMessage = null;

      if (this.product.product_id == null || this.product.product_id.length === 0) {
        errorField.push('รหัสผลิตภัณฑ์');
      }

      if (this.createMode && (this.product.name_en == null || this.product.name_en.length === 0)) {
        errorField.push('ชื่อผลิตภัณฑ์');
      }

      if (errorField.length > 0) {
        this.errorMessage = 'โปรดกรอก ' + errorField.join(', ') + ' ให้ถูกต้อง';
        return;
      }
    } else {
      const errorField = [];
      this.errorMessage = null;

      if (this.product.product_id == null || this.product.product_id.length === 0) {
        errorField.push('Product ID');
      }

      if (this.createMode && (this.product.name_en == null || this.product.name_en.length === 0)) {
        errorField.push('Product name');
      }

      if (errorField.length > 0) {
        this.errorMessage = 'Please fill ' + errorField.join(', ') + ' correctly';
        return;
      }
    }

    let request = null;

    if (this.createMode) {
      this.product.name_th = this.product.name_en;
      const vat = this.product.vat.replace(/,/g, '');
      if (vat) {
        this.product.vat = parseFloat(vat);
      }
      request = this.apiService.createProduct(this.product);
    } else {
      this.product.name_th = this.product.name_en;
      const vat = this.product.vat.replace(/,/g, '');
      if (vat) {
        this.product.vat = parseFloat(vat);
      }
      request = this.apiService.updateProduct(this.product.id, this.product);
    }

    request.subscribe(
      (obj) => {
        if (this.createMode) {
          this.sniff('CREATE_PRODUCT', this.product.product_id + ':' + this.product.name_en + this.product.name_th + ':' + this.product.vat);
        } else {
          this.sniff('UPDATE_PRODUCT', this.product.product_id + ':' + this.product.name_en + this.product.name_th + ':' + this.product.vat);
        }
        this.parent.reload();
        this.modalRef.hide();
        this.clearData();
      },
      error => {
        console.log(error)
        this.checkErrorMsg(error);
      }
    );
  }

  checkErrorMsg(error) {
    this.errorMessage = this.apiService.getErrorMessage(error);
  }

  clearData() {
    this.product = {};
    this.companyGroupID = null;
    this.errorMsgForShow = null;
  }

  close() {
    this.modalRef.hide();
    this.clearData();
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_PRODUCT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list-detail/product-list-detail.component.ts